<template>
  <d-form>
    <d-form-row class="form-group mb-2 pt-2">
      <d-col cols="12">
        <d-card class="mb-1 shadow-none border border-1 rounded">
          <d-card-header
            class="p-3 d-flex w-100 rounded"
            role="tab"
            @click.native="toggleOptions"
          >
            <span class="d-flex align-items-center justify-content-center mr-2">
              <i class="fas fa-chevron-right" :class="{ rotated: optionsOpen }" />
            </span>
            <label class="d-flex justify-content-center align-items-center mb-0 text-center font-weight-bold">Configurações padrão</label>
          </d-card-header>

          <d-collapse :visible="optionsOpen" class="px-4 pb-4" id="default-settings">
            <d-form-row class="pt-3">
              <d-col cols="12" md="4">
                <d-checkbox toggle v-model="options.removeAccents" class="custom-toggle-sm">
                  Remover acentos
                </d-checkbox>
                <d-checkbox toggle v-model="options.removeDuplicates" class="custom-toggle-sm">
                  Remover duplicadas
                </d-checkbox>
                <d-checkbox toggle v-model="options.sortAlphabetically" class="custom-toggle-sm">
                  Ordenar lista
                </d-checkbox>
              </d-col>

              <d-col cols="12" md="4">
                <div class="d-flex align-items-center mt-1">
                  <label class="mb-0 mr-2">Ignorar palavras com até:</label>
                  <d-form-input
                    type="number"
                    v-model.number="model.minWordLength"
                    min="1"
                    max="20"
                    class="w-25"
                  />
                  <label class="mb-0 ml-2">letras</label>
                  <i
                    id="tooltip-min-word-length"
                    class="fas fa-info-circle text-muted ml-2"
                    style="cursor: pointer"
                  />
                  <d-tooltip target="tooltip-min-word-length" placement="top">
                    Palavras com quantidade de letras igual ou menor que esse valor serão ignoradas.
                  </d-tooltip>
                </div>
              </d-col>
            </d-form-row>
          </d-collapse>
        </d-card>
      </d-col>
    </d-form-row>

    <d-form-row class="form-group mb-1">
      <d-col cols="12" md="6">
        <label>Texto:</label>
        <textarea
          v-model="model.inputText"
          class="form-control editor-text-area"
        />
      </d-col>

      <d-col cols="12" md="6">
        <label>Texto gerado:</label>
        <textarea
          v-model="model.resultText"
          class="form-control editor-text-area"
        />
      </d-col>
    </d-form-row>

    <d-form-row class="form-group">
      <d-col cols="12" md="6" class="pt-1">
        <action-buttons :onGenerate="onGenerate" :onClear="onClear" />
      </d-col>

      <d-col cols="12" md="6" class="d-flex align-items-center justify-content-between pt-1">
        <label class="mb-0">
          Total de palavras: <strong>{{ model.processedWords.length }}</strong>
        </label>
        <label class="mb-0 text-muted">
          Ignoradas: <strong>{{ model.ignoredCount }}</strong>
        </label>

        <d-button
          type="button"
          class="btn btn-success btn-sm"
          :disabled="!hasResult"
          @click="onDownload"
        >
          Baixar
        </d-button>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import ActionButtons from '_shared/ActionButtons.vue';
import { processText, wordsToPlainText } from '_utils/breakTextUtils';

export default {
  name: 'break-text-form',
  components: {
    Editor,
    ActionButtons,
  },
  data() {
    return {
      quill: null,
      optionsOpen: false,
      options: {
        toLowerCase: true,
        removeAccents: false,
        removePunctuation: true,
        removeDuplicates: true,
        sortAlphabetically: false,
      },
      model: {
        inputText: '',
        resultText: '',
        processedWords: [],
        ignoredCount: 0,
        minWordLength: 3,
      },
    };
  },
  computed: {
    hasResult() {
      return this.model.processedWords.length > 0;
    },
  },
  methods: {
    ...mapActions(['activeAlert']),
    toggleOptions() {
      this.optionsOpen = !this.optionsOpen;
    },
    onGenerate() {
      const { words, ignoredCount } = processText(
        this.model.inputText,
        this.model.minWordLength,
        this.options,
      );

      if (words.length === 0) {
        this.activeAlert({
          message: `Nenhuma palavra encontrada com mais de ${this.model.minWordLength} letras.`,
          theme: 'warning',
        });
        return;
      }

      this.model.processedWords = words;
      this.model.ignoredCount = ignoredCount;
      this.model.resultText = wordsToPlainText(words);
    },
    onClear() {
      this.model.inputText = '';
      this.model.resultText = '';
      this.model.processedWords = [];
      this.model.ignoredCount = 0;
    },
    onDownload() {
      if (!this.hasResult) return;

      this.triggerFileDownload(
        'palavras-geradas.txt',
        this.model.resultText,
        'text/plain',
      );
    },
    triggerFileDownload(filename, content, mimeType) {
      const blob = new Blob([content], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.download = filename;
      link.href = url;
      link.click();

      window.URL.revokeObjectURL(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.rotated {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.editor-text-area {
  height: 200px;
  resize: vertical;
  font-size: 0.875rem;
  line-height: 1.5;

  &:focus,
  &:hover {
    border-color: #cccccc !important;
    box-shadow: none;
    outline: none;
  }
}
</style>
